module.exports = __webpack_public_path__ + "static/media/rules@2x.4b6187ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/rules@2x.png
// module id = 1243
// module chunks = 0